import { request } from '@services'

export const state = {
  loading: false,
  data: null,
  errors: null,
}

export const getters = {
  getDeviceUserList(state) {
    return state.data
  },
}

export const mutations = {
  SET_DEVICE_LIST_REQUESTED(state) {
    state.loading = true
  },
  SET_DEVICE_LIST_RECEIVED(state, newData) {
    state.loading = false
    state.data = newData
    state.errors = null
  },
  SET_DEVICE_LIST_RECEIVED_FAILED(state, error) {
    state.loading = false
    state.errors = error
  },
  RESET_DEVICE_USER_LIST(state) {
    state.loading = false
    state.data = null
    state.errors = null
  },
}

export const actions = {
  async fetchingDeviceUserList({ commit }, params) {
    commit('SET_DEVICE_LIST_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/device/user_list/',
        payload: { ...params },
      })
      commit('SET_DEVICE_LIST_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_DEVICE_LIST_RECEIVED_FAILED', error)
    }
  },
  resetDeviceUserList({ commit }) {
    commit('RESET_DEVICE_USER_LIST')
  },
  async deleteDeviceById({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/device/unbind/',
        payload: { ...params },
      })
      return response
    } catch (error) {
      return error
    }
  },
}
